import {useContext, useState} from 'react'

import {ATOM_ICON_COLORS, ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeAutosuggest from '@s-ui/react-molecule-autosuggest'
import MoleculeAutosuggestOption, {MoleculeDropdownOptionTextWrapStyles} from '@s-ui/react-molecule-dropdown-option'
import {useRouter} from '@s-ui/react-router'
import IconCircleCloseFilled from '@adv-mt/mt-svg-icons/lib/CircleCloseFilled'
import IconSearch from '@adv-mt/mt-svg-icons/lib/Search'

const EMPTY_SUGGESTS = []

const SearchNews = () => {
  const {domain, i18n} = useContext(Context)
  const router = useRouter()
  const [suggests, setSuggests] = useState(EMPTY_SUGGESTS)
  const [autosuggestValue, setAutosuggestValue] = useState('')

  const _handleChange = async term => {
    let suggests = EMPTY_SUGGESTS

    if (term) {
      const {suggestions} = await domain.get('suggest_news_search_use_case').execute({term})
      suggests = suggestions
    }

    setSuggests(suggests)
  }

  const _handleSubmit = async term => {
    if (!term) return
    const formattedTag = await domain.get('get_formatted_tag_news_search_use_case').execute({tag: term})
    const url = await domain.get('news_search_url_use_case').execute({searchTerm: formattedTag})
    router.push(url)
  }

  const _handleSelect = ({content: term}) => {
    setSuggests(EMPTY_SUGGESTS)
    _handleSubmit(term)
  }

  const _handleSelectRefresh = (event, {value}) => {
    _handleSelect({content: value})
  }

  const _handleChangeRefresh = (event, {value}) => {
    _handleChange(value)
    setAutosuggestValue(value)
  }

  const _handleSubmitRefresh = () => {
    _handleSubmit(autosuggestValue)
  }

  return (
    <div className="mt-SearchNews">
      <div className="mt-SearchNews-inner">
        <MoleculeAutosuggest
          onChange={_handleChangeRefresh}
          onSelect={_handleSelectRefresh}
          onEnter={_handleSubmitRefresh}
          value={autosuggestValue}
          placeholder={i18n.t('SEARCH_NEWS_PLACEHOLDER')}
          onKeyDown={() => {}}
          leftIcon={
            <div className="mt-SearchNews-iconWrapper">
              <IconSearch size={ATOM_ICON_SIZES.medium} color={ATOM_ICON_COLORS.currentColor} />
            </div>
          }
          {...(autosuggestValue && {
            onClickRightIcon: () => setAutosuggestValue(''),
            rightIcon: (
              <div className="mt-SearchNews-iconWrapper">
                <IconCircleCloseFilled size={ATOM_ICON_SIZES.medium} color={ATOM_ICON_COLORS.currentColor} />
              </div>
            )
          })}
        >
          {suggests.map(item => (
            <MoleculeAutosuggestOption
              key={item.model}
              value={item.content}
              textWrap={MoleculeDropdownOptionTextWrapStyles.LINE_WRAP}
            >
              {item.content}
            </MoleculeAutosuggestOption>
          ))}
        </MoleculeAutosuggest>
      </div>
    </div>
  )
}

SearchNews.displayName = 'SearchNews'

export default SearchNews
